import { UpdatePopup, UpdatePopupResponse } from "./";
import { Utility } from "../../../../utils";
import { Api } from "../../../../services/Api";

export class UpdateGroupPopup extends UpdatePopup<{}> {

    public doUpdatePromise(abstractId?: number, gradingGroupId?: number): Promise<UpdatePopupResponse> {
        if (!abstractId || abstractId === 0)
            return Utility.failedPromise("Abstract ID cannot be undefined or zero.");

        return new Promise((resolve, reject) => {
            const updatePromise = this.props.api.put<any>(Api.endpoints.admin.abstract.abstractGradingGroup, {
                body: JSON.stringify({
                    abstractIds: [abstractId],
                    gradingGroupId,
                }),
            });

            updatePromise.then(
                (result) => {
                    if (result.isSuccess && result.data)
                        resolve({
                            abstractId: result.data.abstractIds[0],
                            selectedId: result.data.gradingGroupIds.length ? result.data.gradingGroupIds[0] : undefined,
                        });
                    else
                        reject(result.errors.join("; "));
                },
                (err) => reject(err),
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/list/components/UpdateGroupPopup.tsx